import type { ReactNode } from 'react';
import { useFeatureBadge } from '../hooks/useFeatureBadge';
import { useI18n } from '../i18n';

interface BadgeWrapperProps {
  featureId: string;
  children: ReactNode;
}

export function BadgeWrapper({ featureId, children }: BadgeWrapperProps) {
  const { isNew, markSeen } = useFeatureBadge(featureId);
  const { t } = useI18n();

  return (
    <span className="relative inline-flex items-center gap-1" onClick={isNew ? markSeen : undefined}>
      {children}
      {isNew && (
        <span
          className="badge-dot badge-dot--pulse"
          aria-label={t('releaseNotes.badgeNew')}
          role="status"
        />
      )}
    </span>
  );
}
